import { type FC, useRef, useState } from "react";

import { useTranslation } from "src/translations";
import { SecondaryButton } from "../../../Buttons/components/ActionButton";

interface LogoUploadButtonProps {
    value?: string;
    onChange?: (base64: string, fileName: string) => void;
    onRemove?: () => void;
    readOnly?: boolean;
}

export const LogoUploadButton: FC<LogoUploadButtonProps> = ({ onChange, onRemove, readOnly, value }) => {
    const { t } = useTranslation();
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [fileName, setFileName] = useState<string | undefined>();

    const handleClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
        const { files } = ev.target;
        const file = files?.item(0);
        if (!file || !onChange) return;

        setFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const result = e.target?.result as string;
            // Strip the "data:<mime>;base64," prefix — send only the raw base64 bytes
            const base64 = result.split(",")[1];
            onChange(base64, file.name);
        };
        reader.readAsDataURL(file);
    };

    const handleRemove = () => {
        setFileName("");
        if (onRemove) onRemove();
    };

    const displayName = fileName ?? value;

    return (
        <>
            <input
                type="file"
                ref={fileInputRef}
                accept="image/*"
                style={{ display: "none" }}
                disabled={readOnly}
                onChange={handleFileChange}
            />

            {!readOnly && displayName ? (
                <SecondaryButton name="button" onClick={handleRemove}>
                    {t("acquirer.operator.removeFile")}
                </SecondaryButton>
            ) : (
                <SecondaryButton name="button" disabled={readOnly} onClick={handleClick}>
                    {t("acquirer.operator.addFile")}
                </SecondaryButton>
            )}
            {displayName && <div>{displayName}</div>}
        </>
    );
};
